import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "3f2b3fe5-d6f3-4b93-9c7c-d36552493c49",
    content: "Structure borne sound",
    options: { image: `${config.ASSETS_URL}/03/15/task/task-1-chart-1.svg` },
  },
  {
    id: "d995700a-dae1-4d21-b888-50ee99275366",
    content: "Airborne sound",
    options: { image: `${config.ASSETS_URL}/03/15/task/task-1-chart-2.svg` },
  },
];

export const task: Task = {
  id: "60d730ca-3658-4f20-b636-3d861d97b372",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: false,
    imageHeight: 350,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d995700a-dae1-4d21-b888-50ee99275366"],
};
